import css from 'styled-jsx/css';

const styles = css.global`#emp-garantia-carro-compare {
  padding: 32px 0;
}

#emp-garantia-carro-compare .compare-titulo {
  margin: 0;
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
}

#emp-garantia-carro-compare .compare-conteudo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

#emp-garantia-carro-compare .compare-conteudo .compare-conteudo-textos {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

#emp-garantia-carro-compare .compare-conteudo .compare-texto {
  color:  #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; 
}

#emp-garantia-carro-compare .compare-conteudo .compare-texto .only-desk {
  display: none;
}

#emp-garantia-carro-compare .compare-btn-simular {
  display: none;
}

#emp-garantia-carro-compare .compare-grafico,
#emp-garantia-carro-compare .compare-grafico img {
  width: 100%;
  max-width: 288px;
}

@media (min-width: 992px) {
  #emp-garantia-carro-compare {
    padding: 64px 0;
  }

  #emp-garantia-carro-compare .compare-titulo {
    font-size: 56px;
    line-height: 120%;
  }

  #emp-garantia-carro-compare .compare-conteudo {
    flex-direction: row;
    align-items: flex-start;
    gap: 56px;
  }

  #emp-garantia-carro-compare .compare-conteudo .compare-conteudo-textos {
    gap: 32px;
  }

  #emp-garantia-carro-compare .compare-conteudo .compare-texto {
    font-size: 24px;
    line-height: 36px; 
  }

  #emp-garantia-carro-compare .compare-conteudo .compare-texto .only-desk {
    display: block;
  }

  #emp-garantia-carro-compare .compare-btn-simular {
    display: flex;
    width: 100%;
    max-width: 272px;
    height: 48px;
  }

  #emp-garantia-carro-compare .compare-grafico,
  #emp-garantia-carro-compare .compare-grafico img {
    max-width: 510px;
  }
}`;

export default styles;